// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'calendar-empty-solid';

export const Component = () => (
  <path d='M24.521 3.921v3.927H0V3.921c0-.239.096-.479.287-.67a.946.946 0 0 1 .67-.288h4.934V1.48c0-.335.143-.479.479-.479.335 0 .478.144.478.479v1.484h10.824V1.48c0-.335.144-.479.479-.479.335 0 .479.144.479.479v1.484h4.933c.239 0 .478.096.67.288a.946.946 0 0 1 .287.67h.001ZM0 8.854v14.703c0 .24.096.479.287.67a.946.946 0 0 0 .67.288h22.606a.94.94 0 0 0 .67-.288.946.946 0 0 0 .288-.67V8.854H0Z' />
);

export const viewBox = '0 0 25 25';
